<template>
    <div v-if="curso === 1">
        <MLPareja/>
    </div>
    <div v-else>
        <MLPBody/>
    </div>
</template>

<script>
import MLPBody from "../components/MLPBody.vue";
import MLPareja from "../components/MLPareja.vue";
import numeral from "numeral";
import "numeral/locales";
numeral.locale("es");

export default {
    name: "LpMovistar",
    components: {
        MLPBody,
        MLPareja
    },
    directives: {
    },
    computed: {
    },
    watch: {

    },
    data() {
        return {
            curso: 0,
            productId: this.$route.params.productId,
        };
    },
    methods: {
    },
    mounted() {
    },
    created() {
        if (this.productId === "1000007084") {
            this.curso = 1;
        }
        /*else if (this.productId === "1000007080"){
            this.curso = 2;
        }else if (this.productId === "1000007098"){
            this.curso = 3;
        }else if (this.productId === "1000007084"){
            this.curso = 4;
        }else if (this.productId === "1000007082"){
            this.curso = 5;
        }else if (this.productId === "1000007090"){
            this.curso = 6;
        }else if (this.productId === "1000007086"){
            this.curso = 7;
        }else if (this.productId === "1000007078"){
            this.curso = 8;
        }else if (this.productId === "1000007088"){
            this.curso = 9;
        }/!*else if (this.productId === "1000007092"){
            this.curso = 10;
        }*!/*/
    },
};
</script>
